// export const API="https://gomanee.com/";
// export const API="https://api.maneecafe.com/";

// export const APIMERTRADE="https://api.mertrades.com/";

export const API="https://api.lottery.maneecafe.com/";

// export const API="http://192.168.100.49:8000";